<template>
  <Primitive
    data-slot="button"
    :data-variant="variant"
    :data-size="size"
    :as="as"
    :as-child="asChild"
    :class="cn(buttonVariants({ variant, size }), props.class)"
  >
    <slot />
  </Primitive>
</template>

<script setup>
defineOptions({ name: 'UiButton' });
import { cn } from '@/shared/utilities/classes';
import { Primitive } from 'reka-ui';
import { buttonVariants } from '.';

const props = defineProps({
  variant: { default: undefined, type: null, required: false },
  size: { default: undefined, type: null, required: false },
  class: {
    default: undefined,
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
  asChild: { default: undefined, type: Boolean, required: false },
  as: { type: null, required: false, default: 'button' },
});
</script>
